// Strategy Orchestrator client — CRUD + status + backtest persistence + test-fire.

import { fetchJson, URLS } from "./client";
import type { BacktestDirection, SaveStrategyRequestDto, StrategyDto, StrategyStatus } from "./types";

export function listStrategies(): Promise<StrategyDto[]> {
  return fetchJson<StrategyDto[]>(`${URLS.orchestrator}/Strategies`);
}

export function createStrategy(req: SaveStrategyRequestDto): Promise<StrategyDto> {
  return fetchJson<StrategyDto>(`${URLS.orchestrator}/Strategies`, { method: "POST", body: req });
}

export function getStrategy(id: string): Promise<StrategyDto> {
  return fetchJson<StrategyDto>(`${URLS.orchestrator}/Strategies/${id}`);
}

export function patchStrategyStatus(id: string, status: StrategyStatus): Promise<StrategyDto> {
  return fetchJson<StrategyDto>(`${URLS.orchestrator}/Strategies/${id}/status`, {
    method: "PATCH",
    body: { status },
  });
}

export function patchStrategyBacktest(id: string, backtest: unknown): Promise<void> {
  return fetchJson<void>(`${URLS.orchestrator}/Strategies/${id}/backtest`, {
    method: "PATCH",
    body: backtest,
  });
}

export function deleteStrategy(id: string): Promise<void> {
  return fetchJson<void>(`${URLS.orchestrator}/Strategies/${id}`, { method: "DELETE" });
}

/**
 * Dev-only test-fire endpoint. Returns the alert delivery summary (fired + fingerprint).
 * Throws if the orchestrator isn't in Development mode (404).
 */
export function testFireStrategy(id: string, direction: BacktestDirection): Promise<{ fired: boolean; fingerprint: string }> {
  return fetchJson<{ fired: boolean; fingerprint: string }>(`${URLS.orchestrator}/Strategies/${id}/test-fire`, {
    method: "POST",
    body: { direction },
  });
}
